"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var routes_1 = require("@dynamynd/routes");

var utilities_1 = require("@dynamynd/utilities");

var react_1 = __importDefault(require("react"));

var enums_1 = require("../../enums");

var ForgotPasswordLink = react_1.default.memo(function (_a) {
  var navigateTo = _a.navigateTo,
      navigation = _a.navigation;
  return react_1.default.createElement(components_lib_1.Button, {
    type: components_lib_1.ButtonTypeEnum.link,
    text: enums_1.FieldLabels.forgotPasswordLink,
    uppercase: false,
    accessibilityLabel: enums_1.FieldLabels.forgotPasswordLink,
    onPress: function onPress() {
      navigateTo(routes_1.RoutesKeysEnum.passwordReset, utilities_1.navigateWithAccessCodeQueryParam(navigation.getParam));
    }
  });
});
exports.default = core_1.withNavigateTo(ForgotPasswordLink);